/* eslint-disable react-hooks/exhaustive-deps */
/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Tue 14 May 2024 14:48:11
 */

//------------------------------------------
import React, { useCallback, useEffect, useState } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Button, Modal } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';

import { getShop } from 'src/helpers';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { URL } from 'src/constants/links';

import PPRCampaign from 'src/assets/images/campaigns/ppr-campaign-popup.svg';

const ProductPerformanceRankingCampaign = (props: WithI18nProps) => {
  const { i18n } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const now = new Date().toLocaleDateString();
      // if (moment().startOf().isAfter(moment('2024-04-15 23:59:59'))) {
      //   return;
      // }

      const shop = getShop();
      const lastDisplay = localStorage.getItem(`${shop}-ProductPerformanceRankingCampaign`);
      const countDisplay = localStorage.getItem(`${shop}-ProductPerformanceRankingCampaignCount`);

      // Be already showed today
      if (lastDisplay && lastDisplay === now) {
        return;
      }
      // Count if display times > 3
      const count = parseInt(countDisplay);
      if (count >= 3) {
        return;
      }

      // Display the popup after 3 seconds since users land on the dashboard
      setTimeout(() => {
        setOpen(true);
      }, 3000);
    } catch (error) {}
  }, []);

  const handleClose = useCallback(() => {
    try {
      const shop = getShop();
      localStorage.setItem(
        `${shop}-ProductPerformanceRankingCampaign`,
        new Date().toLocaleDateString()
      );
      const countDisplay = localStorage.getItem(`${shop}-ProductPerformanceRankingCampaignCount`);
      const count = countDisplay ? parseInt(countDisplay) : 0;
      localStorage.setItem(`${shop}-ProductPerformanceRankingCampaignCount`, count + 1);
    } catch (error) {
    } finally {
      setOpen(false);
    }
  }, []);

  const handleBtnClick = () => {
    history.push(routes.productPerformanceRanking.view());
    handleClose();
  };

  const handleLearnMore = () => {
    window.open(URL['Link_Search_Product_Performance_Ranking_Guide'], '_blank');
    handleClose();
  };

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      noScroll
      id="ppr-campaign-popup"
      titleHidden>
      <div className="ppr-campaign-popup">
        <div className="ppr-close-btn">
          <Button onClick={handleClose} icon={MobileCancelMajor} plain />
        </div>
        <div className="ppr-campaign-content">
          <div>{i18n.translate('AdminHTML.Common.ProductPerformanceRankingPopup.title')}</div>

          <div>{i18n.translate('AdminHTML.Common.ProductPerformanceRankingPopup.content')}</div>
        </div>

        <div className="image">
          {/* Image content */}
          <img src={PPRCampaign} alt={`ppr-feature-campaign-img`} />
          {/* Explore button */}
          <div className="actions">
            <Button onClick={() => handleLearnMore()}>
              {i18n.translate('AdminHTML.Common.ProductPerformanceRankingPopup.action01')}
            </Button>
            <Button primary onClick={() => handleBtnClick()}>
              {i18n.translate('AdminHTML.Common.ProductPerformanceRankingPopup.action02')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default withI18n()(ProductPerformanceRankingCampaign);
